<template>
  <div class="expenditure">
    <!-- 表单搜索 start -->
    <section class="form">
      <div class="form-item">
        <span class="label">集配中心：</span>
        <el-select
          class="jn-input-style"
          v-model="from.logistic_business_id"
          clearable
          placeholder="选择集配中心"
        >
          <el-option
            v-for="item of Filterdata"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="form-item">
        <span class="label">周期：</span>
        <el-select
          v-model="order_cycle"
          clearable
          placeholder="选择周期"
          @change="changcycle"
        >
          <el-option
            v-for="item of orderCycleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>

      <div class="form-item">
        <el-date-picker
          v-show="order_cycle == '1'"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="dateTime"
          @change="(val) => changeCreateDate(val, 'daterange')"
        >
        </el-date-picker>
        <el-date-picker
          v-show="order_cycle == '2'"
          v-model="weekTime"
          @change="(val) => changeCreateDate(val, 'week')"
          type="week"
          format="yyyy 第 WW 周"
          placeholder="选择周"
        >
        </el-date-picker>
        <el-date-picker
          v-show="order_cycle == '3'"
          v-model="monthTime"
          @change="(val) => changeCreateDate(val, 'month')"
          type="month"
          placeholder="选择月"
        >
        </el-date-picker>
      </div>
      <div class="form-item">
        <span class="label">装卸队：</span>
        <el-select
          class="jn-input-style"
          v-model="from.fleet_id"
          clearable
          placeholder="选择装卸队"
        >
          <el-option
            v-for="item of Filterdata2"
            :key="item.id"
            :label="item.fleetName"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="form-item btn-wrap">
        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 5px"
          icon="el-icon-refresh"
          class="refresh"
          @click="onHandleRefresh"
        ></el-button>
      </div>
    </section>
    <!-- 表单搜索 end -->

    <div class="auto-table-flex expenditurecnt" v-if="datalist">
      <div class="box1">
        <div class="box1-item" style="background-color: #f4f5f6">
          <div >{{datalist.totalIncome}}</div>
          <div >总收入</div>
          
        </div>
        <div class="box1-item" style="background: radial-gradient( 0% 0% at 0% 0%, #F18A36 0%, #F16B36 100%);">
          <div>{{datalist.totalExpend}}</div>
          <div>总支出</div>
          
        </div>
        <div class="box1-item" style="background: radial-gradient( 0% 0% at 0% 0%, #4A7CE6 0%, #6E99F4 100%);">
          <div>{{datalist.walletAmount}}</div>
          <div>结余</div>
          
        </div>
      </div>
      <div class="box2">
        <div class="box2-item" style="background: #FAF7FF;" v-for="(item,index) in datalist.fleetIncome" :key="index">
          <div style="color: #000" class="div">{{item.amount}}</div>
          <div style="color: #000">{{item.flowTypeText}}</div>
          <div class="xia" @click="onHandleExportinfo(item)">
            <i
              class="el-icon-download"
              style="color: #000; font-size: 20px"
            ></i>
          </div>
        </div>
      </div>
     <div class="box2">
         <div class="box2-item" style="background-color: #F8F8F8;" v-for="(item,index) in datalist.fleetDeduction" :key="index">
          <div style="color: #000" class="div">{{item.amount}}</div>
          <div style="color: #000">{{item.flowTypeText}}</div>
         <div class="xia" @click="onHandleExportinfo(item)">
            <i
              class="el-icon-download"
              style="color: #000; font-size: 20px"
            ></i>
          </div>
        </div>
      
      </div>


           <div class="box2">
         <div class="box2-item" style="background-color: #E7F7F0;" v-for="(item,index) in datalist.fleetReceived" :key="index">
          <div style="color: #000" class="div">{{item.amount}}</div>
          <div style="color: #000">{{item.flowTypeText}}</div>
         <div class="xia" @click="onHandleExportinfo(item)">
            <i
              class="el-icon-download"
              style="color: #000; font-size: 20px"
            ></i>
          </div>
        </div>
      
      </div>
      
    </div>
  </div>
</template>
<script>
import { formatDate } from "@/utils/tools/date.js";
export default {
  name: "lauud",
  components: {},
  data() {
    return {
      loading: false,
      dateTime: [], // 日期对象
      weekTime: "",
      monthTime: "",
      order_cycle: "3",
      from: {
        logistic_business_id: "", //	T文本	是	集配中心id
        fleet_id: "", //	T文本	是	装卸队id
        time_start: "", //	T文本	是
        time_end: "", //	T文本	是	结束时间
      },
      from1: "",
      Filterdata: [],
      Filterdata2: [],
      orderCycleList: [
        {
          id: "1",
          name: "日",
        },
        {
          id: "2",
          name: "周",
        },
        {
          id: "3",
          name: "月",
        },
      ],
      datalist:''
    };
  },
  watch: {},
  created() {
    this.onResetTime();
    this.monthTime = this.getMonthStart();
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
    this.getsearch();
    // this.getflowtype();
    this.getfleetlist();
  },
  watch: {},
  methods: {
    changcycle() {
      this.dateTime = [];
      this.weekTime = "";
      this.monthTime = "";
      this.from.time_start = "";
      this.from.time_end = "";
      this.dateTime = [];
    },
    // 获取 当月开始时间（yyyy-MM-dd 00:00:00）
    getMonthStart() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth(); // 月份从0开始，不用+1

      const startDate = new Date(year, month, 1); // 当月1号 00:00:00
      return this.formatDateTime(startDate);
    },

    // 获取 当月结束时间（yyyy-MM-dd 23:59:59）
    getMonthEnd() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth();

      // 下个月0号 = 当月最后一天
      const endDate = new Date(year, month + 1, 0, 23, 59, 59);
      return this.formatDateTime(endDate);
    },

    // 时间格式化工具（转成 yyyy-MM-dd）
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    /**
     * 重置时间
     */
    onResetTime() {
      this.from.time_start = this.getMonthStart();
      this.from.time_end = this.getMonthEnd();
    },

    /**
     * 日期发生了变化
     */
    changeCreateDate(data, type) {
      if (!data) {
        this.onResetTime();
        return;
      }
      let day = 24 * 60 * 60 * 1000;
      let start = "";
      let end = "";
      if (type === "daterange") {
        start = data?.[0] || "";
        end = data?.[1] || "";
      }
      if (type === "week") {
        let startNum = data.getTime() - day;
        let endNum = data.getTime() + day * 5;
        start = formatDate(startNum);
        end = formatDate(endNum);
      }
      if (type === "month") {
        let num = new Date(
          data.getYear() % 100,
          data.getMonth() + 1,
          0
        ).getDate();
        start = formatDate(data);
        let endNum = data.getTime() + day * (num - 1);
        end = formatDate(endNum);
      }
      // console.log("🆒 changeCreateDate", data, start, end);
      this.from.time_start = start;
      this.from.time_end = end;
    },

    /**
     * 导出逻辑
     */
    async onHandleExportinfo(e) {
        console.log('111111111')
      this.disabledExport = true;
      try {
        const query = {
          ...this.from,
          fleet_id:e.fleetId,
          flow_type:e.flowType,
          token: sessionStorage.getItem("token"),
        };
      

        this.$api.fz.detailexport(query).then((res) => {
          this.goExportCenter();
        });
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax getAfterSaleNewUnExport err", err);
        console.log("ajax postPurchaseSettleExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },

    /**
     * 导出逻辑
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.from,
          token: sessionStorage.getItem("token"),
        };
      

        this.$api.fz.statementexport(query).then((res) => {
          this.goExportCenter();
        });
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax getAfterSaleNewUnExport err", err);
        console.log("ajax postPurchaseSettleExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    getfleetlist() {
      this.$api.fz
        .fleetlist({
          type: 1,
        })
        .then((res) => {
          this.Filterdata2 = res.data;
        });
    },

    getsearch() {
      this.$api.ban.searchdata().then((res) => {
        console.log(res, "qqqqewq");
        this.Filterdata = res.data.business_list;
      });
    },
    onHandleRefresh() {
      this.order_cycle = "3";
      Object.assign(this.$data.from, this.$options.data().from);
      this.onResetTime();
      this.from1 = JSON.parse(JSON.stringify(this.from));
      this.hqlist();
    },

    onHandleSearch() {
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.fz.walletstatement(this.from).then((res) => {
        console.log(res, "获取数据");
this.datalist=res.data;
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.expenditure {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .form {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 13px 15px;
    box-sizing: border-box;
    background: #ffffff;
    &-item {
      display: flex;
      .label {
        width: 90px;
        height: 36px;
        line-height: 36px;
        text-align: right;
      }
      .el-input {
        flex: 1;
      }
      &.btn-wrap {
        position: relative;
        top: -2.5px;
        left: 20px;
      }
    }
    .refresh {
      background: #333333;
      border-color: #333333;
    }
  }
  .contents {
    padding: 0 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .expenditurecnt {
    padding: 30px;
    margin-top: 20px;
    box-sizing: border-box;
    background-color: #ffffff;
    overflow-y: auto;
    .box1 {
      display: flex;
      gap: 30px;
      margin-bottom: 30px;
      .box1-item {
        height: 132px;
        box-sizing: border-box;
        border-radius: 10px 10px 10px 10px;
        div {
          font-size: 30px;
        }
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
       background: radial-gradient( 0% 0% at 0% 0%, #17AE69 0%, #25C37B 100%);
       font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 27px;
color: #FFFFFF;
        padding: 50px;
        position: relative;
        .xia {
          position: absolute;
          bottom: 0px;
          right: 30px;
        }
      }
    }
    .box2 {
      display: flex;
      gap: 30px;
      margin-bottom: 30px;
      flex-wrap: wrap;
      .box2-item {
        width: 375px;
        height: 132px;
        box-sizing: border-box;
        border-radius: 10px 10px 10px 10px;
        .div {
       font-size: 27px;
        }
        // flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: #dd6b05;
  
        // padding: 0 50px;
        position: relative;
        font-size: 15px;
        .xia {
          position: absolute;
          bottom: 0px;
          right: 30px;
        }
      }
    }
  }
}
</style>
